import PropTypes from 'prop-types';
import { Form } from 'formik';
import { FormattedMessage } from 'react-intl';

import SubmitFormButton from 'views/shared/SubmitFormButton';
import Button from 'views/shared/Button';

const ResetPasswordRequestResendFormComponent = ({
  email,
  redirectToLogin,
}) => (
  <div className="container">
    <div className="row">
      <div className="col-12 col-sm-6 offset-sm-3">
        <div className="auth">
          <h1 className="auth__title">
            <FormattedMessage id="resetPassword.checkEmail" />
          </h1>
          <img src="/static/images/auth/mailbox.svg" alt="" className="auth__img" />
          <p className="auth__txt">
            <FormattedMessage id="resetPassword.sendRecoveryLink" />
            <br />
            <span className="auth__caption--mark">{email}</span>
          </p>
          <p className="auth__txt">
            <FormattedMessage id="resetPassword.requestNewLink" />
          </p>
          <Form>
            <div className="auth__btns">
              <Button
                kind="back"
                text={{ id: 'resetPassword.backToLogin' }}
                icon="arrow-left"
                className="main-btn--back-center"
                isLink
                href={redirectToLogin}
              />
              <SubmitFormButton
                className="auth__submit"
                text={{ id: 'resetPassword.resendLink' }}
              />
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
);

ResetPasswordRequestResendFormComponent.propTypes = {
  email: PropTypes.string.isRequired,
  redirectToLogin: PropTypes.string.isRequired,
};

export default ResetPasswordRequestResendFormComponent;
